export default __webpack_public_path__ + "static/media/subcategory-img-2.403b0643.png";